import { render, staticRenderFns } from "./BusinessPayments.vue?vue&type=template&id=20ebbf68&scoped=true&"
import script from "./BusinessPayments.vue?vue&type=script&lang=js&"
export * from "./BusinessPayments.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPayments.vue?vue&type=style&index=0&id=20ebbf68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebbf68",
  null
  
)

export default component.exports